import { Heart, Share2 } from "lucide-react";
import { Link } from "react-router-dom";
import { canNativeShare, nativeShare, telegramShareUrl } from "@/lib/share";

export const SupportCTA = () => {
  const tellAFriendClass =
    "inline-flex items-center gap-2 px-6 py-3 rounded-xl text-muted-foreground hover:text-foreground transition-colors";

  return (
    <section className="py-16 px-5 md:px-8">
      <div className="container mx-auto max-w-2xl text-center">
        <Heart className="w-8 h-8 mx-auto mb-4 text-primary" />
        <h2 className="text-2xl font-black mb-3">Keep Quizrun Running</h2>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          Quizrun is built by two people who love running and puzzles. Your
          support helps us organise more events in more cities.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/support"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground font-bold hover:bg-primary/90 transition-colors"
          >
            Support Quizrun
            <span aria-hidden="true">❤️</span>
          </Link>
          {canNativeShare() ? (
            <button
              type="button"
              onClick={nativeShare}
              className={tellAFriendClass}
            >
              <Share2 className="w-4 h-4" />
              Tell a friend
            </button>
          ) : (
            <a
              href={telegramShareUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className={tellAFriendClass}
            >
              <Share2 className="w-4 h-4" />
              Tell a friend
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
